module.exports = __webpack_public_path__ + "images/interview-IBM-2.svg";